(function ($) {
  /**
   * MAIN MENU
   */


  // Mostrar submenús que contienen un enlace con aria-current="page"
  $('.sub-menu a[aria-current="page"]').parents(".sub-menu").show();

  // Evento de clic en el elemento <li> que contiene un submenú
  $(".main-menu > li:has(> .sub-menu)").click(function (event) {
    // Solo prevenir el comportamiento por defecto si se hace clic en el elemento que tiene un submenú
    event.preventDefault();

    // Seleccionar solo el submenú directamente dentro de este <li>
    var submenu = $(this).children(".sub-menu");

    // Alternar la visibilidad del submenú seleccionado
    submenu.slideToggle();

    // Opcional: cerrar otros submenús abiertos al abrir uno nuevo
    $(".sub-menu").not(submenu).slideUp();
  });

  // Permitir que los enlaces dentro de los sub-menús funcionen normalmente
  $(".sub-menu a").click(function (e) {
    e.stopPropagation(); // Esto impide que el evento de clic se propague hacia arriba
  });

  // Asegurarse de que los enlaces dentro de los li que no tienen sub-menú funcionen normalmente
  $(".main-menu > li:not(:has(> .sub-menu)) > a").click(function () {
    window.location = $(this).attr("href");
  });






  /**
   * AMAGAR I MOSTRAR MAIN
   */

  // Verificar si la clase 'home' no está en el body
  if (!$("body").hasClass("home")) {
    // Evento cuando el mouse entra sobre un elemento con clase 'lateral'
    $(".sidebar").mouseenter(function () {
      // Agrega la clase 'is-active' al elemento con clase 'sidebar'
      $(".sidebar").addClass("is-active");
      $(".main-content").addClass("is-active");
      //$("body").css("overflow", "hidden");
    });

    // Evento cuando el mouse sale de un elemento con clase 'lateral'
    $(".sidebar").mouseleave(function () {
      // Quita la clase 'is-active' del elemento con clase 'sidebar'
      $(".sidebar").removeClass("is-active");
      $(".main-content").removeClass("is-active");
      //$("body").css("overflow", "");
    });
  }

  /**
   * GRID
   */

// init Masonry
var $grid = $('.grid').masonry({
  itemSelector: '.grid-item'
});
// layout Masonry after each image loads
$grid.imagesLoaded().progress( function() {
  $grid.masonry('layout');
});


//Lightbox options

lightbox.option({
  'resizeDuration': 400,
  'showImageNumberLabel': false
})

//synopsis

$(".synopsis--title").on("click", function() {
  $("body").addClass("synopsis-is-active");
  $(".grid").fadeOut();
  $(".synopsis--content").fadeIn();
  $(".synopsis--close").fadeIn();
});

$(".synopsis--close").on("click", function() {
  $("body").removeClass("synopsis-is-active");
  $(".grid").fadeIn();
  $(".synopsis--content").fadeOut(0);
  $(".synopsis--close").fadeOut(0);
});



})(jQuery);
("use strict");
